import { ApolloError } from '@apollo/client';

import { useTeacherDetailQuery, TeacherDetailQuery } from 'core/graphql';

export type ITeacherDetail = NonNullable<TeacherDetailQuery['teacher']>;

interface ITeacherDetailHook {
  teacher?: ITeacherDetail;
  loading: boolean;
  error?: ApolloError;
  refetch: () => void;
}

/** Backs `/teachers/:id/details` — `teacher(teacherId)` resolver. */
export const useTeacherDetail = (id?: string): ITeacherDetailHook => {
  const { data, loading, error, refetch } = useTeacherDetailQuery({
    variables: { id: id || '' },
    skip: !id,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  return {
    teacher: data?.teacher ?? undefined,
    loading,
    error,
    refetch: () => {
      refetch();
    },
  };
};
